<template>
    <div class="modal-body" style="text-align: left;">
        <dl class="dl-horizontal">
            <dt>{{ $t('backend.dsgvo_documentation.type') }}</dt>
            <dd>{{ type }}</dd>
            <dt>E-Mail</dt>
            <dd>{{ sent_to_mail }}</dd>
            <dt>{{ $t('backend.dsgvo_documentation.created_at') }}</dt>
            <dd>{{ created_at }}</dd>
            <dt>{{ $t('backend.dsgvo_documentation.confirmed_at') }}</dt>
            <dd>{{ confirmed_at }}</dd>
            <dt>{{ $t('backend.dsgvo_documentation.ip_address') }}</dt>
            <dd>{{ ip_address }}</dd>
            <dt>{{ $t('backend.dsgvo_documentation.comment') }}</dt>
            <dd>{{ nl2br(comment) }}</dd>
            <template v-if="email_text != ''">
                <dt>{{ $t('backend.dsgvo_documentation.email_text') }}</dt>
                <dd v-html="email_text"></dd>
            </template>
            <template v-if="right_of_withdrawal_text != ''">
                <dt>{{ $t('backend.dsgvo_documentation.right_of_withdrawal_text') }}</dt>
                <dd v-html="right_of_withdrawal_text"></dd>
            </template>
        </dl>
    </div>
</template>
<script>
    export default {
        name: 'DsgvoDocumentationDetail',
        data() {
            return {
                comment: '',
                created_at: '',
                confirmed_at: '',
                type: '',
                email_text: '',
                right_of_withdrawal_text: '',
                ip_address: '',
                sent_to_mail: ''
            }
        },
        mounted() {
            this.$eventHub.$on('show-dsgvo-modal', (data) => {
                this.comment = data.data.comment;
                this.created_at = data.data.created_at;
                this.confirmed_at = data.data.confirmed_at;
                this.type = data.data.type_translated;
                this.email_text = data.data.email_text;
                this.right_of_withdrawal_text = data.data.right_of_withdrawal_text;
                this.ip_address = data.data.ip_address;
                this.sent_to_mail = data.data.sent_to_mail;
            });
        },
        methods: {
            nl2br: function (string) {
                return (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
            },
        }
    }
</script>
